var React = require('react');

function Devpost (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"XMLID_1_"},[React.createElement("path",{"id":"XMLID_6_","d":"M133.7,76H118v90h14.7c30.9,0,45.1-18.1,45.1-45C177.8,90.9,164.9,76,133.7,76z","key":0}),React.createElement("path",{"id":"XMLID_9_","d":"M210.2,0H70.1L0,121l70.1,121h140.1l70.1-121L210.2,0z M132.7,195H89V47h45.8c42.1,0,73.3,20.1,73.3,74\n\t\tC208.1,172.8,170.6,195,132.7,195z","key":1})]));
}

Devpost.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 281 270","enableBackground":"new 5 0 280 270","xmlSpace":"preserve"};

module.exports = Devpost;

Devpost.default = Devpost;
